// Fetch list

export const FETCH = 'surchargeTypes.FETCH'
export const FETCH_STARTED = 'surchargeTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'surchargeTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'surchargeTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'surchargeTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'surchargeTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'surchargeTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'surchargeTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'surchargeTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'surchargeTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'surchargeTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'surchargeTypes.SAVE'
export const SAVE_STARTED = 'surchargeTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'surchargeTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'surchargeTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'surchargeTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'surchargeTypes.DELETE'
export const DELETE_STARTED = 'surchargeTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'surchargeTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'surchargeTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'surchargeTypes.DELETE_CANCELLED'

// Export

export const EXPORT = 'surchargeTypes.EXPORT'
export const EXPORT_FULFILLED = 'surchargeTypes.EXPORT_FULFILLED'
